import React, { useEffect, useState } from 'react';
import {
  ContentContainer,
  DrawerTitleContainer,
  MainContainer,
  SummaryButton,
  SummaryText,
  ChevronIcon,
  SidebarContainer,
} from '../../../components/atoms/tableData/styles/contentContainer.styles';
import SubHeaderPLPast from '../../../components/atoms/subHeaderText/subHeaderPLPast'; //for past page
import PursuitLeaderPastTable from '../../../components/templates/pursuitLeader/forecast/tableComponent/pursuitLeaderPastTable'; //for past forecast
import PlPastSideBar from '../../../components/templates/pursuitLeader/forecast/sideBarComponent/plPastSideBar.component'; //for past side basr
import Drawer from 'react-modern-drawer';
import 'react-modern-drawer/dist/index.css';
import DownChevron from '../../../components/assets/icons/down-chevron.png';
import AlertBanner from '../../../components/atoms/alerts/alertBanner';
import { Recoil_Summary_Drawer_Toggle } from '../../../recoil/recoil';
import { useRecoilState, useRecoilValue } from 'recoil';

function PursuitLeadePastForecast(props) {
  const [isOpen, setIsOpen] = useState(false);
  const [summaryDrawerToggle, setSummaryDrawerToggle] = useRecoilState(
    Recoil_Summary_Drawer_Toggle,
  );

  useEffect(async () => {
    if (isOpen) toggleDrawer();
  }, [summaryDrawerToggle]);

  const toggleDrawer = () => {
    setIsOpen(isOpen => !isOpen);
  };

  let forecast_type = props.data.forecast_type;
  let year = props.data.year;
  let month = props.data.month;
  month = month.charAt(0).toUpperCase() + month.slice(1);
  let quarter = props.data.quarter;
  let email = props.data.email;

  return (
    <>
      <MainContainer>
        <ContentContainer>
          <AlertBanner
            title={'NOTE'}
            description={'This is a view-only snapshot of the forecast you submitted.'}
            type={'past'}
          />
          <SubHeaderPLPast
            year={year}
            forecast_type={forecast_type}
            month={month}
            quarter={quarter}
          />
          <PursuitLeaderPastTable
            email={email}
            year={year}
            month={month}
            quarter={quarter}
            forecast_type={forecast_type}
          />
        </ContentContainer>

        <SidebarContainer>
          <PlPastSideBar data={props.data} />
        </SidebarContainer>

        <SummaryButton onClick={toggleDrawer}>
          <DrawerTitleContainer>
            <ChevronIcon
              src={DownChevron}
              alt="Expand Icon"
              className={!isOpen ? 'expanded' : 'collapsed'}
            />
            <SummaryText>Summary</SummaryText>
          </DrawerTitleContainer>
        </SummaryButton>

        <Drawer
          className="forecast-drawer"
          duration={250}
          onClose={toggleDrawer}
          direction="bottom"
          open={isOpen}
          overlayOpacity="0.6"
          zIndex={100}
        >
          <PlPastSideBar data={props.data} />
        </Drawer>
      </MainContainer>
    </>
  );
}

export default PursuitLeadePastForecast;
